// Auto-generated by /app/scripts/build_i18n.py
export const CONCEPT_TRANSLATIONS = {
 "strings": {
  "cpp": {
   "title": "String Manipulation",
   "subtitle": "Work with text data",
   "concept": "std::string methods and mutability",
   "explanation": "In C++ you work with text using std::string from the <string> header. It is a class (not a primitive), and unlike Java strings it is mutable, so you can change it in place with things like s[0] = 'J', += or append(). Some operations, such as substr(), return a new string and leave the original alone. Get the length with .length() or .size(), access characters with s[i] (unchecked) or s.at(i) (checked), and compare with == (it compares the contents for std::string). Be careful with raw C-style strings (const char*): == on those compares addresses, not text.",
   "keyPoints": [
    "std::string is mutable: you can modify it in place (s += \"!\", s[0] = 'J')",
    "Length: s.length() or s.size() with parentheses (a method call)",
    "Char at index: s[i] (no bounds check) or s.at(i) (throws std::out_of_range if invalid)",
    "Compare content: a == b works for std::string, but == on const char* compares pointers",
    "Concatenate with +, += or .append(); to add a number use std::to_string(n)"
   ],
   "codeExamples": [
    {
     "title": "Basic operations",
     "code": "#include <iostream>\n#include <string>\n#include <cctype>\n\nint main() {\n    std::string s = \"Hello Kapil\";\n    std::cout << s.length() << \"\\n\";   // 11\n    std::cout << s.at(6) << \"\\n\";      // K\n    std::cout << s.substr(6) << \"\\n\";   // Kapil (new string)\n    for (char& c : s) c = std::toupper(static_cast<unsigned char>(c));\n    std::cout << s << \"\\n\";            // HELLO KAPIL (changed in place)\n}",
     "output": "11\nK\nKapil\nHELLO KAPIL"
    },
    {
     "title": "Comparison",
     "code": "#include <iostream>\n#include <string>\n\nint main() {\n    std::cout << std::boolalpha;\n    std::string a = \"hello\";\n    std::string b = \"hello\";\n    std::cout << (a == b) << \"\\n\";              // true: compares content\n    std::cout << (a.compare(b) == 0) << \"\\n\";   // true: also content\n\n    const char* p = a.c_str();\n    const char* q = b.c_str();\n    std::cout << (p == q) << \"\\n\";              // false: compares addresses!\n    std::cout << (std::string(p) == q) << \"\\n\"; // true: back to content\n}",
     "output": "true\ntrue\nfalse\ntrue"
    }
   ],
   "quiz": [
    {
     "question": "What does std::string(\"Java\")[1] return?",
     "options": [
      "'J'",
      "'a'",
      "'v'",
      "'J' as int"
     ],
     "correctIndex": 1,
     "explanation": "Indexing is 0-based: [0]='J', [1]='a', [2]='v', [3]='a'. So index 1 is 'a'."
    },
    {
     "question": "Which is the correct way to compare the contents of two std::string objects?",
     "options": [
      "s1 == s2",
      "s1.equals(s2)",
      "s1.same(s2)",
      "&s1 == &s2"
     ],
     "correctIndex": 0,
     "explanation": "std::string overloads == to compare contents. There is no equals() or same() member. &s1 == &s2 only checks whether both names refer to the very same object."
    },
    {
     "question": "What does std::string(\"Java\") + std::to_string(5) evaluate to?",
     "options": [
      "9",
      "\"Java5\"",
      "Compile error",
      "\"Java 5\""
     ],
     "correctIndex": 1,
     "explanation": "std::to_string(5) produces the string \"5\", and + joins the two strings into \"Java5\". Writing std::string(\"Java\") + 5 directly would not compile, because a string can't be added to an int."
    }
   ]
  },
  "python": {
   "title": "String Manipulation",
   "subtitle": "Work with text data",
   "concept": "String methods and immutability",
   "explanation": "In Python, a string (type str) is an immutable sequence of characters. Once created, it cannot be changed. Methods like .upper() or .replace() don't modify the original string; they return a new one. Get the length with len(s), access characters with s[i], and compare contents with == (use is only to check whether two names refer to the exact same object).",
   "keyPoints": [
    "Strings are immutable: s[0] = 'J' raises a TypeError",
    "Length: len(s), a built-in function, not a method",
    "Character at an index: s[i] (negative indexes count from the end, so s[-1] is the last character)",
    "Compare content with ==; is checks object identity, not text",
    "Join strings with + or an f-string, but you can't add a str and an int with + (convert with str() first)"
   ],
   "codeExamples": [
    {
     "title": "Basic operations",
     "code": "s = \"Hello Kapil\"\nprint(len(s))        # 11\nprint(s[6])          # K\nprint(s.upper())     # HELLO KAPIL\nprint(s[6:])         # Kapil",
     "output": "11\nK\nHELLO KAPIL\nKapil"
    },
    {
     "title": "Comparison",
     "code": "a = \"hello\"\nb = \"hello\"\nprint(a == b)        # True: same content\n\nc = \"\".join([\"h\", \"e\", \"l\", \"l\", \"o\"])\nprint(a == c)        # True: use == for text\nprint(a is c)        # False: different objects",
     "output": "True\nTrue\nFalse"
    }
   ],
   "quiz": [
    {
     "question": "What does \"Python\"[1] return?",
     "options": [
      "'P'",
      "'y'",
      "'t'",
      "An error"
     ],
     "correctIndex": 1,
     "explanation": "Indexing starts at 0. \"Python\"[0] is 'P' and \"Python\"[1] is 'y'."
    },
    {
     "question": "Which is the correct way to compare the contents of two strings?",
     "options": [
      "s1 == s2",
      "s1.compare(s2)",
      "s1.equals(s2)",
      "s1.same(s2)"
     ],
     "correctIndex": 0,
     "explanation": "In Python, == compares the actual content of strings. Python strings have no .equals() method, and is only checks whether both names point to the same object."
    },
    {
     "question": "What does \"Python\" + 5 do?",
     "options": [
      "Evaluates to \"Python5\"",
      "Evaluates to \"Python 5\"",
      "Raises a TypeError",
      "Evaluates to 11"
     ],
     "correctIndex": 2,
     "explanation": "Python does not automatically convert numbers to strings with +. You must write \"Python\" + str(5) or f\"Python{5}\" to get \"Python5\"."
    }
   ]
  },
  "c": {
   "title": "String Manipulation",
   "subtitle": "Work with text data",
   "concept": "Strings as null-terminated char arrays and the <string.h> functions",
   "explanation": "C has no built-in String type. A string is just an array of char that ends with a special null terminator, '\\0'. A string literal like \"Hello\" is stored in read-only memory and must not be modified, so assign it to a const char * if you only need to read it. If you want text you can change, copy it into a char array: char s[] = \"Hello\";. Because strings are arrays, you cannot compare them with == (that compares addresses) or copy them with =. Use the <string.h> functions instead: strlen() for length, strcmp() to compare, strcpy() to copy and strcat() to join. Always make sure your array is big enough to hold the text plus the '\\0'.",
   "keyPoints": [
    "A string is a char array ending with '\\0' (the null terminator)",
    "Length: strlen(s) — counts characters, not the '\\0'",
    "Char at index: s[i] (0-based, no bounds checking!)",
    "Compare content: strcmp(a, b) == 0 — NOT a == b, which compares addresses",
    "Join with strcat() or snprintf(), and make sure the destination array is large enough; string literals are read-only, so copy them into a char array to modify them"
   ],
   "codeExamples": [
    {
     "title": "Basic operations",
     "code": "#include <stdio.h>\n#include <string.h>\n#include <ctype.h>\n\nint main(void) {\n    char s[] = \"Hello Kapil\";\n    printf(\"%zu\\n\", strlen(s));   // 11\n    printf(\"%c\\n\", s[6]);        // K\n    printf(\"%s\\n\", s + 6);       // Kapil\n    for (int i = 0; s[i]; i++)\n        s[i] = toupper((unsigned char)s[i]);\n    printf(\"%s\\n\", s);           // HELLO KAPIL\n    return 0;\n}",
     "output": "11\nK\nKapil\nHELLO KAPIL"
    },
    {
     "title": "Comparison",
     "code": "#include <stdio.h>\n#include <string.h>\n\nint main(void) {\n    char a[] = \"hello\";\n    char b[] = \"hello\";\n    const char *p = a;\n    printf(\"%d\\n\", a == b);              // 0 - different addresses\n    printf(\"%d\\n\", strcmp(a, b) == 0);   // 1 - same content, use this!\n    printf(\"%d\\n\", a == p);              // 1 - p points to the same array\n    printf(\"%d\\n\", strcmp(a, p) == 0);   // 1\n    return 0;\n}",
     "output": "0\n1\n1\n1"
    }
   ],
   "quiz": [
    {
     "question": "Given char s[] = \"Java\"; what is s[1]?",
     "options": [
      "'J'",
      "'a'",
      "'v'",
      "'\\0'"
     ],
     "correctIndex": 1,
     "explanation": "Array indexes start at 0: s[0]='J', s[1]='a', s[2]='v', s[3]='a', s[4]='\\0'. So s[1] is 'a'."
    },
    {
     "question": "Which is the correct way to check whether two strings have the same contents?",
     "options": [
      "s1 == s2",
      "s1.equals(s2)",
      "strcmp(s1, s2) == 0",
      "strlen(s1, s2) == 0"
     ],
     "correctIndex": 2,
     "explanation": "strcmp returns 0 when the contents are equal. == only compares addresses, and C has no .equals() because strings are not objects."
    },
    {
     "question": "How many bytes does char s[] = \"Java\"; occupy?",
     "options": [
      "4",
      "5",
      "6",
      "8"
     ],
     "correctIndex": 1,
     "explanation": "The array holds the 4 characters J, a, v, a plus the null terminator '\\0', so sizeof(s) is 5 even though strlen(s) is 4."
    }
   ]
  }
 },
 "for-loop": {
  "c": {
   "title": "For Loops",
   "subtitle": "Repeat code a fixed number of times",
   "concept": "Iteration with counter-based loops",
   "explanation": "A for loop repeats a block of code. It has 3 parts: initialization (runs once), condition (checked before each iteration), and update (runs after each iteration). In C11 you can declare the counter right inside the loop (for (int i = 0; ...)), and it only exists inside that loop. For loops are ideal when you know how many times to repeat, like walking through an array. C arrays don't carry their length with them, so you either keep the size in a variable or compute it with sizeof(arr) / sizeof(arr[0]). Kapil's tip: always double-check your condition so you don't read past the end of an array!",
   "keyPoints": [
    "for (init; condition; update) { body }",
    "Initialization typically declares a counter (int i = 0); in C11 it is scoped to the loop",
    "The loop continues only while the condition is true (nonzero)",
    "Update usually increments/decrements the counter",
    "C has no for-each loop; to visit every array element, loop over indices up to the array's size",
    "Compute an array's element count with sizeof(arr) / sizeof(arr[0]) (only works on real arrays, not on pointers)"
   ],
   "codeExamples": [
    {
     "title": "Basic counting",
     "code": "#include <stdio.h>\n\nint main(void) {\n    for (int i = 1; i <= 5; i++) {\n        printf(\"Count: %d\\n\", i);\n    }\n    return 0;\n}",
     "output": "Count: 1\nCount: 2\nCount: 3\nCount: 4\nCount: 5"
    },
    {
     "title": "Sum an array",
     "code": "#include <stdio.h>\n\nint main(void) {\n    int nums[] = {10, 20, 30, 40};\n    size_t len = sizeof(nums) / sizeof(nums[0]);\n    int sum = 0;\n    for (size_t i = 0; i < len; i++) {\n        sum += nums[i];\n    }\n    printf(\"Sum: %d\\n\", sum);\n    return 0;\n}",
     "output": "Sum: 100"
    },
    {
     "title": "Looping over an array (no for-each in C)",
     "code": "#include <stdio.h>\n\nint main(void) {\n    int nums[] = {1, 2, 3};\n    size_t len = sizeof(nums) / sizeof(nums[0]);\n    for (size_t i = 0; i < len; i++) {\n        printf(\"%d\\n\", nums[i] * 2);\n    }\n    return 0;\n}",
     "output": "2\n4\n6"
    }
   ],
   "quiz": [
    {
     "question": "How many times does this loop run?\nfor (int i = 0; i < 10; i++) { ... }",
     "options": [
      "9",
      "10",
      "11",
      "Infinite"
     ],
     "correctIndex": 1,
     "explanation": "i goes from 0 to 9 (10 values total). The loop stops when i becomes 10 because i < 10 is false."
    },
    {
     "question": "What is the final value of sum?\nint sum = 0;\nfor (int i = 1; i <= 4; i++) sum += i;",
     "options": [
      "4",
      "6",
      "10",
      "15"
     ],
     "correctIndex": 2,
     "explanation": "sum = 0+1+2+3+4 = 10. i takes values 1, 2, 3, 4 before the condition fails at i=5."
    },
    {
     "question": "Given int arr[5] and size_t len = 5, which loop visits every element of the array exactly once?",
     "options": [
      "for (size_t i = 0; i < len; i++)",
      "for (size_t i = 1; i < len; i++)",
      "for (size_t i = 0; i <= len; i++)",
      "for (size_t i = 0; i < len - 1; i++)"
     ],
     "correctIndex": 0,
     "explanation": "Array indices go from 0 to len-1. Starting at 0 and continuing while i < len covers all elements. Using i <= len would read past the end, which is undefined behavior in C."
    }
   ]
  },
  "cpp": {
   "title": "For Loops",
   "subtitle": "Repeat code a fixed number of times",
   "concept": "Iteration with counter-based loops",
   "explanation": "A for loop repeats a block of code. It has 3 parts: initialization (runs once), condition (checked before each iteration), and update (runs after each iteration). In C++, for loops are ideal when you know how many times to repeat, like walking through the elements of a std::vector or an array. C++ also has a range-based for loop (for (int n : nums)) that visits every element without needing a counter.",
   "keyPoints": [
    "for (init; condition; update) { body }",
    "Initialization typically declares a counter (int i = 0)",
    "The loop continues only while the condition is true",
    "Update usually increments/decrements the counter",
    "Use nums.size() for a std::vector; it returns std::size_t (unsigned), so compare with a std::size_t counter",
    "Range-based for (for (int n : nums)) visits every element without a counter"
   ],
   "codeExamples": [
    {
     "title": "Basic counting",
     "code": "#include <iostream>\n\nint main() {\n    for (int i = 1; i <= 5; i++) {\n        std::cout << \"Count: \" << i << \"\\n\";\n    }\n    return 0;\n}",
     "output": "Count: 1\nCount: 2\nCount: 3\nCount: 4\nCount: 5"
    },
    {
     "title": "Sum a vector",
     "code": "#include <iostream>\n#include <vector>\n\nint main() {\n    std::vector<int> nums = {10, 20, 30, 40};\n    int sum = 0;\n    for (std::size_t i = 0; i < nums.size(); i++) {\n        sum += nums[i];\n    }\n    std::cout << \"Sum: \" << sum << \"\\n\";\n    return 0;\n}",
     "output": "Sum: 100"
    },
    {
     "title": "Range-based for loop",
     "code": "#include <iostream>\n#include <vector>\n\nint main() {\n    std::vector<int> nums = {1, 2, 3};\n    for (int n : nums) {\n        std::cout << n * 2 << \"\\n\";\n    }\n    return 0;\n}",
     "output": "2\n4\n6"
    }
   ],
   "quiz": [
    {
     "question": "How many times does this loop run?\nfor (int i = 0; i < 10; i++) { ... }",
     "options": [
      "9",
      "10",
      "11",
      "Infinite"
     ],
     "correctIndex": 1,
     "explanation": "i goes from 0 to 9 (10 values total). The loop stops when i becomes 10 because i < 10 is false."
    },
    {
     "question": "What is the final value of sum?\nint sum = 0;\nfor (int i = 1; i <= 4; i++) sum += i;",
     "options": [
      "4",
      "6",
      "10",
      "15"
     ],
     "correctIndex": 2,
     "explanation": "sum = 0+1+2+3+4 = 10. i takes values 1, 2, 3, 4 before the condition fails at i=5."
    },
    {
     "question": "Which loop visits every element of a std::vector<int> named v?",
     "options": [
      "for (std::size_t i = 0; i < v.size(); i++)",
      "for (std::size_t i = 1; i < v.size(); i++)",
      "for (std::size_t i = 0; i <= v.size(); i++)",
      "for (std::size_t i = 0; i < v.size() - 1; i++)"
     ],
     "correctIndex": 0,
     "explanation": "Indices go from 0 to size()-1. Starting at 0 and continuing while i < size() covers all elements. Using <= would read past the end, which is undefined behavior in C++."
    }
   ]
  },
  "python": {
   "title": "For Loops",
   "subtitle": "Repeat code for each item in a sequence",
   "concept": "Iteration with for loops and range()",
   "explanation": "A for loop repeats a block of code. In Python, a for loop goes through the items of a sequence (like a list, a string, or a range of numbers) one at a time. There is no separate initialization, condition, or update step. Python takes the next item and assigns it to the loop variable on each pass, then stops when there are no items left. Use range() when you want to repeat something a fixed number of times, and loop directly over a list when you want to visit each of its items.",
   "keyPoints": [
    "Syntax: for item in sequence: followed by an indented body",
    "range(stop) counts from 0 up to stop - 1; range(start, stop) begins at start; range(start, stop, step) changes the step",
    "The stop value in range() is never included",
    "The loop variable is assigned automatically on each iteration, so you do not update it yourself",
    "Loop directly over a list with for n in nums; you rarely need an index"
   ],
   "codeExamples": [
    {
     "title": "Basic counting",
     "code": "for i in range(1, 6):\n    print(\"Count:\", i)",
     "output": "Count: 1\nCount: 2\nCount: 3\nCount: 4\nCount: 5"
    },
    {
     "title": "Sum a list",
     "code": "nums = [10, 20, 30, 40]\ntotal = 0\nfor n in nums:\n    total += n\nprint(\"Sum:\", total)",
     "output": "Sum: 100"
    },
    {
     "title": "Using range() with indexes",
     "code": "nums = [1, 2, 3]\nfor i in range(len(nums)):\n    print(nums[i] * 2)",
     "output": "2\n4\n6"
    }
   ],
   "quiz": [
    {
     "question": "How many times does this loop run?\nfor i in range(10):\n    ...",
     "options": [
      "9",
      "10",
      "11",
      "Infinite"
     ],
     "correctIndex": 1,
     "explanation": "range(10) produces the numbers 0 through 9, which is 10 values. The stop value 10 is not included."
    },
    {
     "question": "What is the final value of total?\ntotal = 0\nfor i in range(1, 5):\n    total += i",
     "options": [
      "4",
      "6",
      "10",
      "15"
     ],
     "correctIndex": 2,
     "explanation": "range(1, 5) gives 1, 2, 3, 4, so total = 0+1+2+3+4 = 10. The stop value 5 is not included."
    },
    {
     "question": "Which loop visits every element of the list arr?",
     "options": [
      "for i in range(len(arr)):",
      "for i in range(1, len(arr)):",
      "for i in range(len(arr) + 1):",
      "for i in range(len(arr) - 1):"
     ],
     "correctIndex": 0,
     "explanation": "List indexes go from 0 to len(arr) - 1. range(len(arr)) produces exactly those indexes. The other options skip the first item, go past the end (causing an IndexError), or skip the last item."
    }
   ]
  }
 },
 "methods": {
  "python": {
   "title": "Functions",
   "subtitle": "Reusable blocks of code",
   "concept": "Define, call, and return values",
   "explanation": "Functions let you package logic so you can reuse it. In Python you define a function with the def keyword, give it a name, list its parameters in parentheses, and write the body indented underneath. You don't declare a return type. A function that doesn't use return automatically gives back None. Functions keep code cleaner and enable patterns like recursion that you'll use later in DSA.",
   "keyPoints": [
    "Syntax: def function_name(param1, param2): followed by an indented body",
    "return sends a value back to the caller and exits the function",
    "A function without a return statement returns None automatically",
    "Parameters are the inputs to the function; the values you pass in when calling are called arguments"
   ],
   "codeExamples": [
    {
     "title": "A simple function",
     "code": "def add(a, b):\n    return a + b\n\nresult = add(5, 3)\nprint(result)",
     "output": "8"
    },
    {
     "title": "A function with no return value",
     "code": "def greet(name):\n    print(f\"Hello, {name}!\")\n\ngreet(\"Kapil\")\ngreet(\"World\")",
     "output": "Hello, Kapil!\nHello, World!"
    }
   ],
   "quiz": [
    {
     "question": "What does the return keyword do?",
     "options": [
      "Restarts the function",
      "Sends a value back and exits the function",
      "Prints a value",
      "Loops the function"
     ],
     "correctIndex": 1,
     "explanation": "return both provides the output value and immediately exits the function."
    },
    {
     "question": "What does a Python function give back if it has no return statement?",
     "options": [
      "0",
      "An empty string",
      "An error",
      "None"
     ],
     "correctIndex": 3,
     "explanation": "If a function finishes without return, Python automatically returns None, which means \"no value\"."
    },
    {
     "question": "Given: def multiply(a, b):\n    return a * b\nWhat is multiply(4, 6)?",
     "options": [
      "10",
      "24",
      "46",
      "2"
     ],
     "correctIndex": 1,
     "explanation": "The function returns a * b = 4 * 6 = 24."
    }
   ]
  },
  "cpp": {
   "title": "Functions",
   "subtitle": "Reusable blocks of code",
   "concept": "Define, call, and return values",
   "explanation": "Functions let you wrap up logic so you can reuse it. In C++, a function has a return type, a name, parameters, and a body. Use void when the function doesn't return anything. A function must be declared before it is called, either by defining it earlier in the file or by writing a prototype. Functions make your code cleaner and enable DSA patterns like recursion. (In C++ they are called functions; when they belong to a class or struct they are called member functions.)",
   "keyPoints": [
    "Signature: returnType functionName(paramType paramName, ...)",
    "return sends a value back and exits the function",
    "void functions don't return a value",
    "Parameters are like inputs to the function",
    "A function must be declared (a prototype is enough) before you call it",
    "Arguments are passed by value (copied) by default"
   ],
   "codeExamples": [
    {
     "title": "A simple function",
     "code": "#include <iostream>\n\nint add(int a, int b) {\n    return a + b;\n}\n\nint main() {\n    int sum = add(5, 3);\n    std::cout << sum << std::endl;  // 8\n    return 0;\n}",
     "output": "8"
    },
    {
     "title": "void function",
     "code": "#include <iostream>\n#include <string>\n\nvoid greet(const std::string& name) {\n    std::cout << \"Hello, \" << name << \"!\" << std::endl;\n}\n\nint main() {\n    greet(\"Kapil\");\n    greet(\"World\");\n    return 0;\n}",
     "output": "Hello, Kapil!\nHello, World!"
    }
   ],
   "quiz": [
    {
     "question": "What does the return keyword do?",
     "options": [
      "Restarts the function",
      "Sends a value back and exits the function",
      "Prints a value",
      "Loops the function"
     ],
     "correctIndex": 1,
     "explanation": "return both provides the output value and immediately exits the function."
    },
    {
     "question": "What return type do you use if a function doesn't return anything?",
     "options": [
      "null",
      "empty",
      "void",
      "None"
     ],
     "correctIndex": 2,
     "explanation": "void means \"no return value\". You can't use return with a value in a void function."
    },
    {
     "question": "Given: int multiply(int a, int b) { return a * b; }\nWhat is multiply(4, 6)?",
     "options": [
      "10",
      "24",
      "46",
      "2"
     ],
     "correctIndex": 1,
     "explanation": "The function returns a * b = 4 * 6 = 24."
    }
   ]
  },
  "c": {
   "title": "Functions",
   "subtitle": "Reusable blocks of code",
   "concept": "Define, call, and return values",
   "explanation": "In C, a function lets you package logic so you can reuse it. A function has a return type, a name, parameters, and a body. Use void when the function doesn't return anything. In C, a function must be declared (or defined) before you call it, so you either define it above main or write a prototype first. Functions make code cleaner and enable DSA patterns like recursion. Note that C passes arguments by value, so a function gets copies of what you pass in.",
   "keyPoints": [
    "Signature: returnType functionName(paramType paramName, ...)",
    "return sends a value back and exits the function",
    "void functions don't return a value",
    "Parameters are inputs; C passes them by value (the function gets copies)",
    "Declare or define a function before calling it (a prototype like int add(int a, int b); works)"
   ],
   "codeExamples": [
    {
     "title": "A simple function",
     "code": "#include <stdio.h>\n\nint add(int a, int b) {\n    return a + b;\n}\n\nint main(void) {\n    int sum = add(5, 3);\n    printf(\"%d\\n\", sum);  // 8\n    return 0;\n}",
     "output": "8"
    },
    {
     "title": "void function",
     "code": "#include <stdio.h>\n\nvoid greet(const char *name) {\n    printf(\"Hello, %s!\\n\", name);\n}\n\nint main(void) {\n    greet(\"Kapil\");\n    greet(\"World\");\n    return 0;\n}",
     "output": "Hello, Kapil!\nHello, World!"
    }
   ],
   "quiz": [
    {
     "question": "What does the return keyword do?",
     "options": [
      "Restarts the function",
      "Sends a value back and exits the function",
      "Prints a value",
      "Loops the function"
     ],
     "correctIndex": 1,
     "explanation": "return both provides the output value and immediately exits the function."
    },
    {
     "question": "What return type do you use if a function doesn't return anything?",
     "options": [
      "null",
      "empty",
      "void",
      "None"
     ],
     "correctIndex": 2,
     "explanation": "void means \"no return value\". You can't return a value from a void function."
    },
    {
     "question": "Given: int multiply(int a, int b) { return a * b; }\nWhat is multiply(4, 6)?",
     "options": [
      "10",
      "24",
      "46",
      "2"
     ],
     "correctIndex": 1,
     "explanation": "The function returns a * b = 4 * 6 = 24."
    }
   ]
  }
 },
 "while-loop": {
  "c": {
   "title": "While Loops",
   "subtitle": "Loop until a condition changes",
   "concept": "Condition-based iteration",
   "explanation": "A while loop in C repeats as long as a condition is true. In C, any nonzero value counts as true and 0 counts as false. While loops are ideal when you don't know in advance how many iterations you need, for example binary search halving a range, or two indexes moving toward each other in an array. Always make sure the condition eventually becomes false, or your program will loop forever. Kapil likes to say: 'Check your loop variable before you run your program!'",
   "keyPoints": [
    "while (condition) { body } checks the condition before each iteration",
    "do { body } while (condition); runs the body at least once, and note the semicolon at the end",
    "Update the loop variable inside the body, or the condition never changes",
    "In C, 0 is false and any nonzero value is true, so while (n) stops when n becomes 0",
    "Watch for infinite loops! Arrays have no .length in C, so compute the size with sizeof(arr) / sizeof(arr[0])"
   ],
   "codeExamples": [
    {
     "title": "Countdown",
     "code": "#include <stdio.h>\n\nint main(void) {\n    int count = 5;\n    while (count > 0) {\n        printf(\"%d\\n\", count);\n        count--;\n    }\n    printf(\"Liftoff!\\n\");\n    return 0;\n}",
     "output": "5\n4\n3\n2\n1\nLiftoff!"
    },
    {
     "title": "Two pointer example",
     "code": "#include <stdio.h>\n\nint main(void) {\n    int arr[] = {1, 2, 3, 4, 5};\n    int left = 0;\n    int right = (int)(sizeof(arr) / sizeof(arr[0])) - 1;\n    while (left < right) {\n        printf(\"%d and %d\\n\", arr[left], arr[right]);\n        left++;\n        right--;\n    }\n    return 0;\n}",
     "output": "1 and 5\n2 and 4"
    }
   ],
   "quiz": [
    {
     "question": "How many times does this print?\nint i = 0;\nwhile (i < 3) { printf(\"Hi\\n\"); i++; }",
     "options": [
      "2",
      "3",
      "4",
      "Infinite"
     ],
     "correctIndex": 1,
     "explanation": "i takes the values 0, 1, 2 (3 iterations). When i is 3, the condition i < 3 is false and the loop exits."
    },
    {
     "question": "What is the KEY difference between while and do-while?",
     "options": [
      "while is faster",
      "do-while runs the body at least once even if the condition is false",
      "do-while cannot use counters",
      "while checks the condition after the body"
     ],
     "correctIndex": 1,
     "explanation": "do-while checks the condition AFTER running the body, so the body always executes at least once."
    },
    {
     "question": "Which mistake creates an infinite loop?\nint i = 5;\nwhile (i > 0) { printf(\"%d\\n\", i); }",
     "options": [
      "Missing i-- inside the loop",
      "i should start at 0",
      "Condition should be i < 0",
      "Nothing wrong"
     ],
     "correctIndex": 0,
     "explanation": "i is never modified inside the loop, so it stays 5 forever and the condition never becomes false."
    }
   ]
  },
  "cpp": {
   "title": "While Loops",
   "subtitle": "Loop until a condition changes",
   "concept": "Condition-based iteration",
   "explanation": "A while loop repeats as long as a condition is true. It's ideal when you don't know how many iterations you need in advance — for example, binary search halving the range, or two pointers moving toward each other. In C++, any value that converts to bool can be a condition (0 is false, non-zero is true). Always ensure the condition eventually becomes false to avoid infinite loops.",
   "keyPoints": [
    "while (condition) { body } — checked before each iteration",
    "do { body } while (condition); — body runs at least once (note the semicolon at the end)",
    "Update the loop variable inside the body",
    "Watch for infinite loops!"
   ],
   "codeExamples": [
    {
     "title": "Countdown",
     "code": "#include <iostream>\n\nint main() {\n    int count = 5;\n    while (count > 0) {\n        std::cout << count << \"\\n\";\n        count--;\n    }\n    std::cout << \"Liftoff!\" << \"\\n\";\n    return 0;\n}",
     "output": "5\n4\n3\n2\n1\nLiftoff!"
    },
    {
     "title": "Two pointer example",
     "code": "#include <iostream>\n#include <vector>\n\nint main() {\n    std::vector<int> arr = {1, 2, 3, 4, 5};\n    int left = 0;\n    int right = static_cast<int>(arr.size()) - 1;\n    while (left < right) {\n        std::cout << arr[left] << \" and \" << arr[right] << \"\\n\";\n        left++;\n        right--;\n    }\n    return 0;\n}",
     "output": "1 and 5\n2 and 4"
    }
   ],
   "quiz": [
    {
     "question": "How many times does this print?\nint i = 0;\nwhile (i < 3) { std::cout << \"Hi\\n\"; i++; }",
     "options": [
      "2",
      "3",
      "4",
      "Infinite"
     ],
     "correctIndex": 1,
     "explanation": "i takes values 0, 1, 2 (3 iterations). At i=3, the condition i<3 is false and the loop exits."
    },
    {
     "question": "What is the KEY difference between while and do-while?",
     "options": [
      "while is faster",
      "do-while runs the body at least once even if the condition is false",
      "do-while cannot use counters",
      "while checks the condition after the body"
     ],
     "correctIndex": 1,
     "explanation": "do-while checks the condition AFTER running the body, so the body always executes at least once."
    },
    {
     "question": "Which mistake creates an infinite loop?\nint i = 5;\nwhile (i > 0) { std::cout << i << \"\\n\"; }",
     "options": [
      "Missing i-- inside the loop",
      "i should start at 0",
      "Condition should be i < 0",
      "Nothing wrong"
     ],
     "correctIndex": 0,
     "explanation": "i is never modified inside the loop, so it stays 5 forever, and the condition never becomes false."
    }
   ]
  },
  "python": {
   "title": "While Loops",
   "subtitle": "Loop until a condition changes",
   "concept": "Condition-based iteration",
   "explanation": "A while loop repeats as long as a condition is true. It's ideal when you don't know how many iterations you need in advance, for example binary search halving the range, or two pointers moving toward each other. Always make sure the condition eventually becomes false to avoid infinite loops. Python has no do-while loop, but you can get the same effect with while True and break.",
   "keyPoints": [
    "while condition: followed by an indented body. The condition is checked before each iteration",
    "Python has no do-while. Use while True: with a break to run the body at least once",
    "Update the loop variable inside the body (Python has no ++ or --, so use count -= 1)",
    "Watch for infinite loops! Press Ctrl+C to stop one in the terminal"
   ],
   "codeExamples": [
    {
     "title": "Countdown",
     "code": "count = 5\nwhile count > 0:\n    print(count)\n    count -= 1\nprint(\"Liftoff!\")",
     "output": "5\n4\n3\n2\n1\nLiftoff!"
    },
    {
     "title": "Two pointer example",
     "code": "arr = [1, 2, 3, 4, 5]\nleft = 0\nright = len(arr) - 1\nwhile left < right:\n    print(f\"{arr[left]} and {arr[right]}\")\n    left += 1\n    right -= 1",
     "output": "1 and 5\n2 and 4"
    }
   ],
   "quiz": [
    {
     "question": "How many times does this print?\ni = 0\nwhile i < 3:\n    print(\"Hi\")\n    i += 1",
     "options": [
      "2",
      "3",
      "4",
      "Infinite"
     ],
     "correctIndex": 1,
     "explanation": "i takes the values 0, 1, 2 (3 iterations). When i is 3, the condition i < 3 is false and the loop exits."
    },
    {
     "question": "Python has no do-while loop. How can you make a loop body run at least once?",
     "options": [
      "Use while True: and break when done",
      "Use a while loop whose condition is always False",
      "Use do: ... while condition",
      "Use a for loop with no body"
     ],
     "correctIndex": 0,
     "explanation": "while True: starts the body unconditionally, and you place an if ...: break inside to exit. This gives do-while behavior, because the condition is checked after the body runs at least once."
    },
    {
     "question": "Which mistake creates an infinite loop?\ni = 5\nwhile i > 0:\n    print(i)",
     "options": [
      "Missing i -= 1 inside the loop",
      "i should start at 0",
      "Condition should be i < 0",
      "Nothing is wrong"
     ],
     "correctIndex": 0,
     "explanation": "i is never modified inside the loop, so it stays 5 forever and the condition never becomes false."
    }
   ]
  }
 },
 "classes-objects": {
  "python": {
   "title": "Classes & Objects",
   "subtitle": "Object-Oriented Programming basics",
   "concept": "Blueprint (class) and instance (object)",
   "explanation": "A class is a blueprint describing what data (attributes) and behavior (methods) an object should have. An object is a specific instance created from that class. In Python you create an object by calling the class like a function, for example Student(). The special __init__ method runs automatically and sets up the new object's data. The first parameter of every method is self, which refers to the object the method is being called on.",
   "keyPoints": [
    "The class keyword defines the blueprint",
    "Calling the class, like Student(), creates an object (no new keyword needed)",
    "Attributes (variables) hold each object's data, usually set in __init__",
    "Methods are functions inside a class that define what objects can do",
    "Use the dot operator (.) to access attributes and methods",
    "self is the first parameter of a method and refers to the current object"
   ],
   "codeExamples": [
    {
     "title": "Define a class",
     "code": "class Student:\n    def __init__(self, name, age):\n        self.name = name\n        self.age = age\n\n    def greet(self):\n        print(f\"Hi, I'm {self.name}\")\n\nprint(\"Blueprint defined\")",
     "output": "Blueprint defined"
    },
    {
     "title": "Create and use objects",
     "code": "class Student:\n    def __init__(self, name, age):\n        self.name = name\n        self.age = age\n\n    def greet(self):\n        print(f\"Hi, I'm {self.name}\")\n\ns1 = Student(\"Kapil\", 20)\ns1.greet()\n\ns2 = Student(\"Aayush\", 21)\ns2.greet()",
     "output": "Hi, I'm Kapil\nHi, I'm Aayush"
    }
   ],
   "quiz": [
    {
     "question": "What is the relationship between a class and an object?",
     "options": [
      "They are the same thing",
      "A class is a blueprint; objects are instances",
      "An object is a blueprint; classes are instances",
      "Neither exists in Python"
     ],
     "correctIndex": 1,
     "explanation": "The class defines what an object looks like. You create actual objects (instances) by calling the class, like Student()."
    },
    {
     "question": "How do you create a new object from a class named Student?",
     "options": [
      "new Student()",
      "create Student()",
      "Student()",
      "instantiate Student()"
     ],
     "correctIndex": 2,
     "explanation": "In Python you call the class like a function. Python creates the object and runs __init__ to set it up. There is no new keyword."
    },
    {
     "question": "How do you access an attribute of an object called car?",
     "options": [
      "car:attribute",
      "car->attribute",
      "car.attribute",
      "car[attribute]"
     ],
     "correctIndex": 2,
     "explanation": "Python uses the dot operator to access attributes and methods of an object, such as car.color or car.drive()."
    }
   ]
  },
  "c": {
   "title": "Structs & Objects",
   "subtitle": "Grouping data and behavior in C",
   "concept": "Blueprint (struct type) and instance (struct variable)",
   "explanation": "C has no classes, but it has structs. A struct is a blueprint that groups related data (members) under one type. A struct variable is a specific instance of that type, with its own copy of the data. C has no methods inside structs, so behavior is written as ordinary functions that take the struct (usually a pointer to it) as a parameter. You create an instance simply by declaring a variable, such as Student s1; there is no new keyword. Kapil's lessons often use this pattern to model real-world things like students.",
   "keyPoints": [
    "struct (often with typedef) defines the blueprint",
    "Declaring a variable like Student s1; creates an instance",
    "Members (variables) hold each instance's own data",
    "Functions that take a struct pointer act like methods",
    "Use . on a struct variable and -> on a pointer to a struct"
   ],
   "codeExamples": [
    {
     "title": "Define a struct and a function",
     "code": "typedef struct {\n    char name[32];\n    int age;\n} Student;\n\nvoid student_greet(const Student *s) {\n    printf(\"Hi, I'm %s\\n\", s->name);\n}",
     "output": ""
    },
    {
     "title": "Create and use struct variables",
     "code": "#include <stdio.h>\n#include <string.h>\n\ntypedef struct {\n    char name[32];\n    int age;\n} Student;\n\nvoid student_greet(const Student *s) {\n    printf(\"Hi, I'm %s\\n\", s->name);\n}\n\nint main(void) {\n    Student s1;\n    strcpy(s1.name, \"Kapil\");\n    s1.age = 20;\n    student_greet(&s1);\n\n    Student s2;\n    strcpy(s2.name, \"Aayush\");\n    student_greet(&s2);\n    return 0;\n}",
     "output": "Hi, I'm Kapil\nHi, I'm Aayush"
    }
   ],
   "quiz": [
    {
     "question": "What is the relationship between a struct type and a struct variable?",
     "options": [
      "They are the same thing",
      "A struct type is a blueprint; variables are instances of it",
      "A variable is a blueprint; struct types are instances",
      "Neither exists in C"
     ],
     "correctIndex": 1,
     "explanation": "The struct type describes what the data looks like. Each variable you declare of that type is an actual instance with its own copy of the members."
    },
    {
     "question": "How do you create an instance of the struct type Student (declared with typedef)?",
     "options": [
      "new Student s;",
      "Student s;",
      "make Student s;",
      "instantiate Student s;"
     ],
     "correctIndex": 1,
     "explanation": "In C you create an instance by declaring a variable of the struct type. There is no new keyword; the variable's memory is allocated automatically (on the stack for local variables)."
    },
    {
     "question": "How do you access a member of a struct variable called car?",
     "options": [
      "car:member",
      "car->member",
      "car.member",
      "car[member]"
     ],
     "correctIndex": 2,
     "explanation": "The dot operator accesses members of a struct variable. If you have a pointer to a struct, use the arrow operator (->) instead."
    }
   ]
  },
  "cpp": {
   "title": "Classes & Objects",
   "subtitle": "Object-Oriented Programming basics",
   "concept": "Blueprint (class/struct) and instance (object)",
   "explanation": "A class is a blueprint describing what data (member variables) and behavior (member functions) an object should have. An object is a specific instance created from that class. In C++, a struct is almost the same as a class, except its members are public by default, which makes it great for beginners. Competitive and DSA solutions often use a \"Solution\" class pattern. In C++ you create an object simply by declaring a variable of the type, like Student s1; (no new needed).",
   "keyPoints": [
    "class or struct defines the blueprint",
    "Declare a variable of the type (Student s1;) to create an object",
    "Member variables hold each object's data",
    "Member functions define what objects can do",
    "Use the dot operator (.) to access members of an object (-> is used with pointers)"
   ],
   "codeExamples": [
    {
     "title": "Define a struct",
     "code": "#include <iostream>\n#include <string>\n\nstruct Student {\n    std::string name;\n    int age;\n\n    void greet() {\n        std::cout << \"Hi, I'm \" << name << \"\\n\";\n    }\n};\n\nint main() {\n    std::cout << \"Blueprint defined\\n\";\n}",
     "output": "Blueprint defined"
    },
    {
     "title": "Create and use objects",
     "code": "#include <iostream>\n#include <string>\n\nstruct Student {\n    std::string name;\n    int age;\n    void greet() {\n        std::cout << \"Hi, I'm \" << name << \"\\n\";\n    }\n};\n\nint main() {\n    Student s1;\n    s1.name = \"Kapil\";\n    s1.age = 20;\n    s1.greet();\n\n    Student s2;\n    s2.name = \"Aayush\";\n    s2.greet();\n}",
     "output": "Hi, I'm Kapil\nHi, I'm Aayush"
    }
   ],
   "quiz": [
    {
     "question": "What is the relationship between a class and an object?",
     "options": [
      "They are the same thing",
      "A class is a blueprint; objects are instances",
      "An object is a blueprint; classes are instances",
      "Neither exists in C++"
     ],
     "correctIndex": 1,
     "explanation": "The class (or struct) defines what an object looks like. You create actual objects (instances) from it by declaring variables of that type."
    },
    {
     "question": "How do you normally create a simple object of type Student in C++?",
     "options": [
      "Student s1 = create Student;",
      "Student s1;",
      "make Student s1;",
      "instantiate Student s1;"
     ],
     "correctIndex": 1,
     "explanation": "Declaring a variable like Student s1; creates an object right away, usually on the stack. No new keyword is required."
    },
    {
     "question": "How do you access a member of an object called car (not a pointer)?",
     "options": [
      "car:field",
      "car->field",
      "car.field",
      "car[field]"
     ],
     "correctIndex": 2,
     "explanation": "C++ uses the dot operator to access members of an object. The arrow (->) is used when you have a pointer to an object."
    }
   ]
  }
 },
 "variables": {
  "c": {
   "title": "Variables & Data Types",
   "subtitle": "The building blocks of every C program",
   "concept": "Learn how C stores information using different data types",
   "explanation": "In C, every variable has a type, and the type decides how much memory it uses and how its bits are interpreted. Basic types include int, double, char, and _Bool (or bool from <stdbool.h>). C has no built-in String type. Text is stored as an array of char that ends with a '\\0' character. Variables must be declared with their type before use, and local variables hold garbage values until you initialize them.",
   "keyPoints": [
    "int stores whole numbers (usually 32 bits, so at least -32767 to 32767 is guaranteed, typically -2^31 to 2^31 - 1)",
    "double stores decimal numbers with high precision (use %f to print it)",
    "bool (from <stdbool.h>) stores true or false; it is really 1 or 0",
    "char stores a single character in single quotes, such as 'A'",
    "Text is a char array in double quotes, like char name[] = \"Kapil\"; it ends with a hidden '\\0'"
   ],
   "codeExamples": [
    {
     "title": "Declaring different types",
     "code": "#include <stdio.h>\n#include <stdbool.h>\n\nint main(void) {\n    int age = 25;\n    double price = 99.99;\n    bool isReady = true;\n    char grade = 'A';\n    char name[] = \"Kapil\";\n\n    printf(\"%s is %d years old\\n\", name, age);\n    return 0;\n}",
     "output": "Kapil is 25 years old"
    },
    {
     "title": "Type casting",
     "code": "#include <stdio.h>\n\nint main(void) {\n    int wholeNumber = 10;\n    double decimal = wholeNumber;  // Automatic conversion\n    double pi = 3.14;\n    int truncated = (int)pi;       // Explicit cast\n    printf(\"%d\\n\", truncated);     // Prints 3\n    return 0;\n}",
     "output": "3"
    }
   ],
   "quiz": [
    {
     "question": "Which data type would you use to store the value 3.14?",
     "options": [
      "int",
      "double",
      "bool",
      "char"
     ],
     "correctIndex": 1,
     "explanation": "double stores decimal numbers. int only stores whole numbers, so 3.14 would be truncated to 3."
    },
    {
     "question": "What is the correct way to declare a text string variable in C?",
     "options": [
      "string name = \"Kapil\";",
      "char name[] = 'Kapil';",
      "char name[] = \"Kapil\";",
      "str name = \"Kapil\";"
     ],
     "correctIndex": 2,
     "explanation": "C has no String type, so text is a char array. Double quotes create a string literal that ends with '\\0'. Single quotes are only for a single char."
    },
    {
     "question": "What is the value of x after: int x = (int)9.8;",
     "options": [
      "9",
      "10",
      "9.8",
      "Error"
     ],
     "correctIndex": 0,
     "explanation": "Casting to int truncates (drops the decimal part). It does not round, so 9.8 becomes 9."
    }
   ]
  },
  "cpp": {
   "title": "Variables & Data Types",
   "subtitle": "The building blocks of every C++ program",
   "concept": "Learn how C++ stores information using different data types",
   "explanation": "In C++, every variable has a type that is fixed when you declare it. Fundamental types (int, double, bool, char) store simple values directly in the variable. Text is usually stored with std::string, a class from the standard library that manages its characters for you. C++ also has references and pointers, which refer to data stored elsewhere. Variables must be declared with their type before use. Note that local variables of fundamental types are not automatically initialized, so always give them a starting value.",
   "keyPoints": [
    "int stores whole numbers (usually 32 bits, about -2 billion to 2 billion, but the exact size depends on the platform)",
    "double stores decimal numbers with high precision",
    "bool stores true or false",
    "char stores a single character in single quotes",
    "std::string stores text in double quotes (include <string>)",
    "Always initialize your variables, e.g. int x = 0; or int x{0};"
   ],
   "codeExamples": [
    {
     "title": "Declaring different types",
     "code": "#include <iostream>\n#include <string>\n\nint main() {\n    int age = 25;\n    double price = 99.99;\n    bool isReady = true;\n    char grade = 'A';\n    std::string name = \"Kapil\";\n\n    std::cout << name << \" is \" << age << \" years old\\n\";\n    return 0;\n}",
     "output": "Kapil is 25 years old"
    },
    {
     "title": "Type casting",
     "code": "#include <iostream>\n\nint main() {\n    int wholeNumber = 10;\n    double decimal = wholeNumber;  // Implicit widening\n    double pi = 3.14;\n    int truncated = static_cast<int>(pi);  // Explicit narrowing\n    std::cout << truncated << \"\\n\";  // Prints 3\n    return 0;\n}",
     "output": "3"
    }
   ],
   "quiz": [
    {
     "question": "Which data type would you use to store the value 3.14?",
     "options": [
      "int",
      "double",
      "bool",
      "char"
     ],
     "correctIndex": 1,
     "explanation": "double stores decimal numbers. int only stores whole numbers, so 3.14 would be truncated to 3."
    },
    {
     "question": "What is the correct way to declare a string variable in C++ (assuming <string> is included)?",
     "options": [
      "string name = \"Kapil\";",
      "std::string name = 'Kapil';",
      "std::string name = \"Kapil\";",
      "str name = \"Kapil\";"
     ],
     "correctIndex": 2,
     "explanation": "The type is std::string (lowercase, in the std namespace), and strings use double quotes. Single quotes are only for a single char. Option 1 would only work if you had written using namespace std; or using std::string;, so option 3 is the correct answer."
    },
    {
     "question": "What is the value of x after: int x = static_cast<int>(9.8);",
     "options": [
      "9",
      "10",
      "9.8",
      "Error"
     ],
     "correctIndex": 0,
     "explanation": "Casting to int truncates (drops the decimal part). It does not round, so 9.8 becomes 9."
    }
   ]
  },
  "python": {
   "title": "Variables & Data Types",
   "subtitle": "The building blocks of every Python program",
   "concept": "Learn how Python stores information using different data types",
   "explanation": "In Python, every value has a type, but you don't declare it. You just assign a value to a name with = and Python figures out the type for you (this is called dynamic typing). Common built-in types include int, float, bool, and str. Variables are names that refer to objects in memory, and the same name can later refer to a value of a different type. You can check a value's type with type().",
   "keyPoints": [
    "int stores whole numbers of any size (Python integers have no fixed limit)",
    "float stores decimal numbers (64-bit double precision)",
    "bool stores True or False (note the capital letters)",
    "str stores text in single or double quotes; Python has no separate char type, a single character is just a str of length 1",
    "No type declaration is needed: the type comes from the value, and you can convert with int(), float(), str()"
   ],
   "codeExamples": [
    {
     "title": "Using different types",
     "code": "age = 25\nprice = 99.99\nis_ready = True\ngrade = 'A'\nname = \"Kapil\"\n\nprint(name + \" is \" + str(age) + \" years old\")",
     "output": "Kapil is 25 years old"
    },
    {
     "title": "Type conversion",
     "code": "whole_number = 10\ndecimal = float(whole_number)\npi = 3.14\ntruncated = int(pi)\nprint(decimal)\nprint(truncated)",
     "output": "10.0\n3"
    }
   ],
   "quiz": [
    {
     "question": "Which data type would you use to store the value 3.14?",
     "options": [
      "int",
      "float",
      "bool",
      "str"
     ],
     "correctIndex": 1,
     "explanation": "float stores decimal numbers. int only stores whole numbers, so converting 3.14 with int() would give 3."
    },
    {
     "question": "What is the correct way to create a string variable in Python?",
     "options": [
      "String name = \"Kapil\"",
      "name = \"Kapil\"",
      "string name = \"Kapil\";",
      "str name = \"Kapil\""
     ],
     "correctIndex": 1,
     "explanation": "In Python you simply assign the value with =. No type is written, and strings can use single or double quotes."
    },
    {
     "question": "What is the value of x after: x = int(9.8)",
     "options": [
      "9",
      "10",
      "9.8",
      "Error"
     ],
     "correctIndex": 0,
     "explanation": "int() truncates a float, dropping the decimal part. It does not round, so 9.8 becomes 9."
    }
   ]
  }
 },
 "recursion-basics": {
  "c": {
   "title": "Recursion Basics",
   "subtitle": "A function that calls itself",
   "concept": "Base case + recursive case",
   "explanation": "Recursion is when a function calls itself to solve a smaller version of the same problem. Every recursive function needs (1) a BASE CASE that stops the recursion, and (2) a RECURSIVE CASE that reduces the problem size. Without a base case, the function never stops calling itself. In C, each call uses a stack frame, so endless recursion eventually overflows the stack and the program crashes (a segmentation fault, which is undefined behavior as far as the C standard is concerned).",
   "keyPoints": [
    "Base case: the simplest input, solved directly without another call",
    "Recursive case: the function calls itself with a smaller or simpler input",
    "Each call adds a stack frame to the call stack, and C does not check for you when the stack runs out",
    "Great for problems that split into similar subproblems",
    "Watch out for overflow: factorial(13) overflows a 32-bit int, so use a wider type like unsigned long long for larger values"
   ],
   "codeExamples": [
    {
     "title": "Factorial (n!)",
     "code": "#include <stdio.h>\n\nint factorial(int n) {\n    /* Base case */\n    if (n <= 1) return 1;\n    /* Recursive case */\n    return n * factorial(n - 1);\n}\n\nint main(void) {\n    printf(\"%d\\n\", factorial(5));  /* 120 */\n    return 0;\n}",
     "output": "120"
    },
    {
     "title": "Sum from 1 to n",
     "code": "#include <stdio.h>\n\nint sum(int n) {\n    if (n == 0) return 0;      /* base */\n    return n + sum(n - 1);     /* recursive */\n}\n\nint main(void) {\n    printf(\"%d\\n\", sum(10));   /* 55 */\n    return 0;\n}",
     "output": "55"
    }
   ],
   "quiz": [
    {
     "question": "What is missing from a recursive function that never terminates?",
     "options": [
      "A return statement",
      "A base case",
      "A loop",
      "A parameter"
     ],
     "correctIndex": 1,
     "explanation": "Without a base case, the function keeps calling itself indefinitely until the call stack is exhausted and the program crashes (stack overflow, typically a segmentation fault)."
    },
    {
     "question": "For factorial(4), how many recursive calls (excluding the initial call)?",
     "options": [
      "3",
      "4",
      "5",
      "24"
     ],
     "correctIndex": 0,
     "explanation": "factorial(4) → factorial(3) → factorial(2) → factorial(1) [base]. That's 3 recursive calls after the initial one."
    },
    {
     "question": "Which is TRUE about recursion?",
     "options": [
      "Recursion is always faster than loops",
      "Every recursion can be written as a loop",
      "Recursion doesn't use memory",
      "Recursion cannot return values"
     ],
     "correctIndex": 1,
     "explanation": "Any recursion can be converted to an iterative loop (sometimes using an explicit stack). Recursion uses stack memory for each call, and it can return values just like any other function."
    }
   ]
  },
  "python": {
   "title": "Recursion Basics",
   "subtitle": "A function that calls itself",
   "concept": "Base case + recursive case",
   "explanation": "Recursion is when a function calls itself to solve a smaller version of the same problem. Every recursive function needs (1) a BASE CASE that stops the recursion, and (2) a RECURSIVE CASE that reduces the problem size. Without a base case, recursion never stops. In Python, this ends with a RecursionError once the call stack gets too deep (the default limit is about 1000 calls).",
   "keyPoints": [
    "Base case: the simplest input, solved directly",
    "Recursive case: calls itself with smaller/simpler input",
    "Each call adds a frame to the call stack",
    "Great for problems that split into similar subproblems",
    "Python raises RecursionError if recursion goes too deep"
   ],
   "codeExamples": [
    {
     "title": "Factorial (n!)",
     "code": "def factorial(n):\n    # Base case\n    if n <= 1:\n        return 1\n    # Recursive case\n    return n * factorial(n - 1)\n\nprint(factorial(5))",
     "output": "120"
    },
    {
     "title": "Sum from 1 to n",
     "code": "def sum_to(n):\n    if n == 0:\n        return 0           # base case\n    return n + sum_to(n - 1)  # recursive case\n\nprint(sum_to(10))",
     "output": "55"
    }
   ],
   "quiz": [
    {
     "question": "What is missing from a recursive function that never terminates?",
     "options": [
      "A return statement",
      "A base case",
      "A loop",
      "A parameter"
     ],
     "correctIndex": 1,
     "explanation": "Without a base case, the function keeps calling itself indefinitely, eventually causing a RecursionError in Python."
    },
    {
     "question": "For factorial(4), how many recursive calls are made (excluding the initial call)?",
     "options": [
      "3",
      "4",
      "5",
      "24"
     ],
     "correctIndex": 0,
     "explanation": "factorial(4) → factorial(3) → factorial(2) → factorial(1) [base case]. That's 3 recursive calls after the initial one."
    },
    {
     "question": "Which is TRUE about recursion?",
     "options": [
      "Recursion is always faster than loops",
      "Every recursion can be written as a loop",
      "Recursion doesn't use memory",
      "Recursion cannot return values"
     ],
     "correctIndex": 1,
     "explanation": "Any recursion can be converted to an iterative loop (sometimes using a stack). Recursion uses call stack memory for each call."
    }
   ]
  },
  "cpp": {
   "title": "Recursion Basics",
   "subtitle": "A function that calls itself",
   "concept": "Base case + recursive case",
   "explanation": "Recursion is when a function calls itself to solve a smaller version of the same problem. Every recursive function needs (1) a BASE CASE that stops the recursion, and (2) a RECURSIVE CASE that reduces the problem size. Without a base case, the function never stops calling itself. Each call uses stack memory, so eventually the program crashes with a stack overflow (in C++ this is undefined behavior, usually a crash or segmentation fault).",
   "keyPoints": [
    "Base case: the simplest input, solved directly",
    "Recursive case: calls itself with smaller/simpler input",
    "Each call adds a stack frame to the call stack",
    "Great for problems that split into similar subproblems",
    "In C++, infinite recursion is undefined behavior and typically crashes the program"
   ],
   "codeExamples": [
    {
     "title": "Factorial (n!)",
     "code": "#include <iostream>\n\nint factorial(int n) {\n    // Base case\n    if (n <= 1) return 1;\n    // Recursive case\n    return n * factorial(n - 1);\n}\n\nint main() {\n    std::cout << factorial(5) << std::endl;  // 120\n    return 0;\n}",
     "output": "120"
    },
    {
     "title": "Sum from 1 to n",
     "code": "#include <iostream>\n\nint sum(int n) {\n    if (n == 0) return 0;      // base\n    return n + sum(n - 1);     // recursive\n}\n\nint main() {\n    std::cout << sum(10) << std::endl;   // 55\n    return 0;\n}",
     "output": "55"
    }
   ],
   "quiz": [
    {
     "question": "What is missing from a recursive function that never terminates?",
     "options": [
      "A return statement",
      "A base case",
      "A loop",
      "A parameter"
     ],
     "correctIndex": 1,
     "explanation": "Without a base case, the function keeps calling itself indefinitely, eventually overflowing the call stack and crashing the program."
    },
    {
     "question": "For factorial(4), how many recursive calls are made (excluding the initial call)?",
     "options": [
      "3",
      "4",
      "5",
      "24"
     ],
     "correctIndex": 0,
     "explanation": "factorial(4) → factorial(3) → factorial(2) → factorial(1) [base]. That's 3 recursive calls after the initial one."
    },
    {
     "question": "Which is TRUE about recursion?",
     "options": [
      "Recursion is always faster than loops",
      "Every recursion can be written as a loop",
      "Recursion doesn't use memory",
      "Recursion cannot return values"
     ],
     "correctIndex": 1,
     "explanation": "Any recursion can be converted to an iterative loop (sometimes using an explicit stack). Recursion uses stack memory for each call."
    }
   ]
  }
 },
 "arrays": {
  "cpp": {
   "title": "Arrays",
   "subtitle": "Store multiple values in one variable",
   "concept": "Fixed-size ordered collections",
   "explanation": "An array holds multiple values of the same type in a fixed-size, ordered block of memory. Access elements by their zero-based index (arr[0] is the first, arr[size-1] is the last). In C++17 you can use a built-in array like int arr[5] or the safer std::array<int, 5> from <array>. Unlike Java, plain C++ arrays do not check your index, so you must stay within bounds yourself. Arrays are the foundation of most DSA problems.",
   "keyPoints": [
    "int arr[5] = {}; creates an array of size 5 with every element set to 0 (without = {} a local array holds garbage values)",
    "int arr[] = {1, 2, 3}; creates an array whose size (3) is deduced from the initializer list",
    "std::size(arr) (from <iterator>, C++17) gives the number of elements of a built-in array; std::array has arr.size()",
    "Accessing arr[size] with [] is undefined behavior (no exception, no guarantee). std::array's .at(i) throws std::out_of_range instead"
   ],
   "codeExamples": [
    {
     "title": "Create and access",
     "code": "#include <iostream>\n#include <iterator>\n\nint main() {\n    int scores[] = {85, 92, 78, 95, 88};\n    std::cout << scores[0] << \"\\n\";           // 85\n    std::cout << scores[4] << \"\\n\";           // 88\n    std::cout << std::size(scores) << \"\\n\";   // 5\n\n    // Modify\n    scores[2] = 80;\n    std::cout << scores[2] << \"\\n\";           // 80\n}",
     "output": "85\n88\n5\n80"
    },
    {
     "title": "Iterate and find max",
     "code": "#include <iostream>\n#include <iterator>\n\nint main() {\n    int nums[] = {3, 7, 2, 9, 5};\n    int max = nums[0];\n    for (std::size_t i = 1; i < std::size(nums); i++) {\n        if (nums[i] > max) {\n            max = nums[i];\n        }\n    }\n    std::cout << \"Max: \" << max << \"\\n\";\n}",
     "output": "Max: 9"
    }
   ],
   "quiz": [
    {
     "question": "Given int arr[] = {10, 20, 30, 40}; what is arr[2]?",
     "options": [
      "10",
      "20",
      "30",
      "40"
     ],
     "correctIndex": 2,
     "explanation": "Arrays are 0-indexed. arr[0]=10, arr[1]=20, arr[2]=30, arr[3]=40."
    },
    {
     "question": "What does std::size(arr) return for int arr[7] = {};?",
     "options": [
      "6",
      "7",
      "8",
      "Compile error"
     ],
     "correctIndex": 1,
     "explanation": "std::size returns the number of elements the array was declared with (7), no matter what values they hold."
    },
    {
     "question": "What happens with arr[std::size(arr)] on a built-in array?",
     "options": [
      "Returns the last element",
      "Always returns 0",
      "Undefined behavior",
      "Throws std::out_of_range"
     ],
     "correctIndex": 2,
     "explanation": "Valid indices are 0 to size-1. Using [] with an out-of-range index is undefined behavior in C++: it might crash, return garbage, or seem to work. Only .at() on std::array or std::vector throws std::out_of_range."
    }
   ]
  },
  "c": {
   "title": "Arrays",
   "subtitle": "Store multiple values under one name",
   "concept": "Fixed-size ordered collections",
   "explanation": "An array in C holds multiple values of the same type in one contiguous block of memory. Its size is fixed when it is declared. Access elements by their zero-based index (arr[0] is the first, arr[n-1] is the last). Unlike some other languages, C arrays do not remember their own length and do not check bounds, so you must keep track of the size yourself. A common trick is sizeof(arr) / sizeof(arr[0]) to compute the element count of a real array in the same scope. Arrays are the foundation of most DSA problems.",
   "keyPoints": [
    "int arr[5]; — creates an array of 5 ints (values are uninitialized garbage for local arrays)",
    "int arr[] = {1, 2, 3}; — array initializer; the size (3) is deduced from the list",
    "int arr[5] = {0}; — sets the first element to 0 and all remaining elements to 0 too",
    "sizeof(arr) / sizeof(arr[0]) gives the number of elements, but only where arr is a real array (not a pointer parameter)",
    "Accessing arr[n] (one past the end) is undefined behavior: C does not check bounds and the program may crash or silently misbehave"
   ],
   "codeExamples": [
    {
     "title": "Create and access",
     "code": "#include <stdio.h>\n\nint main(void) {\n    int scores[] = {85, 92, 78, 95, 88};\n    size_t length = sizeof(scores) / sizeof(scores[0]);\n\n    printf(\"%d\\n\", scores[0]);\n    printf(\"%d\\n\", scores[4]);\n    printf(\"%zu\\n\", length);\n\n    scores[2] = 80;\n    printf(\"%d\\n\", scores[2]);\n    return 0;\n}",
     "output": "85\n88\n5\n80"
    },
    {
     "title": "Iterate and find max",
     "code": "#include <stdio.h>\n\nint main(void) {\n    int nums[] = {3, 7, 2, 9, 5};\n    size_t n = sizeof(nums) / sizeof(nums[0]);\n    int max = nums[0];\n    for (size_t i = 1; i < n; i++) {\n        if (nums[i] > max) {\n            max = nums[i];\n        }\n    }\n    printf(\"Max: %d\\n\", max);\n    return 0;\n}",
     "output": "Max: 9"
    }
   ],
   "quiz": [
    {
     "question": "Given int arr[] = {10, 20, 30, 40}; what is arr[2]?",
     "options": [
      "10",
      "20",
      "30",
      "40"
     ],
     "correctIndex": 2,
     "explanation": "Arrays are 0-indexed. arr[0]=10, arr[1]=20, arr[2]=30, arr[3]=40."
    },
    {
     "question": "For int arr[7]; in the same scope, what does sizeof(arr) / sizeof(arr[0]) evaluate to?",
     "options": [
      "6",
      "7",
      "8",
      "It depends on the values stored"
     ],
     "correctIndex": 1,
     "explanation": "sizeof(arr) is the total bytes of 7 ints and sizeof(arr[0]) is the bytes of one int, so the division gives 7, whether or not the elements have been assigned."
    },
    {
     "question": "What happens with arr[n] when arr has n elements?",
     "options": [
      "Returns the last element",
      "Always returns 0",
      "Undefined behavior (no automatic bounds check)",
      "The compiler always reports an error"
     ],
     "correctIndex": 2,
     "explanation": "Valid indices are 0 to n-1. C does not check bounds, so reading or writing arr[n] is undefined behavior: it might crash, return garbage, or corrupt other data."
    }
   ]
  },
  "python": {
   "title": "Lists (Python's Arrays)",
   "subtitle": "Store multiple values in one variable",
   "concept": "Ordered, indexable collections",
   "explanation": "In Python, the everyday 'array' is the list. A list holds multiple values in an ordered sequence. Unlike Java arrays, a list can grow and shrink, and it can even hold values of different types (though keeping them the same type is good practice). Access elements by their zero-based index (nums[0] is the first, nums[-1] is the last). Lists are the foundation of most DSA problems in Python.",
   "keyPoints": [
    "scores = [85, 92, 78] creates a list using a list literal",
    "zeros = [0] * 5 creates a list of size 5 filled with 0",
    "len(scores) gives the size (it is a function, so it needs parentheses)",
    "Accessing scores[len(scores)] raises an IndexError, while scores[-1] safely gives the last element"
   ],
   "codeExamples": [
    {
     "title": "Create and access",
     "code": "scores = [85, 92, 78, 95, 88]\nprint(scores[0])\nprint(scores[4])\nprint(len(scores))\n\n# Modify\nscores[2] = 80\nprint(scores[2])",
     "output": "85\n88\n5\n80"
    },
    {
     "title": "Iterate and find max",
     "code": "nums = [3, 7, 2, 9, 5]\nmax_value = nums[0]\nfor i in range(1, len(nums)):\n    if nums[i] > max_value:\n        max_value = nums[i]\nprint(\"Max:\", max_value)",
     "output": "Max: 9"
    }
   ],
   "quiz": [
    {
     "question": "Given arr = [10, 20, 30, 40], what is arr[2]?",
     "options": [
      "10",
      "20",
      "30",
      "40"
     ],
     "correctIndex": 2,
     "explanation": "Lists are 0-indexed. arr[0]=10, arr[1]=20, arr[2]=30, arr[3]=40."
    },
    {
     "question": "What is len(arr) for arr = [0] * 7?",
     "options": [
      "6",
      "7",
      "8",
      "Error"
     ],
     "correctIndex": 1,
     "explanation": "[0] * 7 creates a list with seven 0s, so len(arr) returns 7."
    },
    {
     "question": "What happens with arr[len(arr)]?",
     "options": [
      "Returns the last element",
      "Returns 0",
      "IndexError",
      "Returns None"
     ],
     "correctIndex": 2,
     "explanation": "Valid indices are 0 to len(arr)-1 (or -1 to -len(arr)). Accessing index len(arr) raises an IndexError."
    }
   ]
  }
 },
 "if-else": {
  "cpp": {
   "title": "Conditional Statements",
   "subtitle": "Make decisions in your code",
   "concept": "if, else if, else, and ternary",
   "explanation": "Conditional statements let your C++ program take different paths based on conditions. Use if to check a condition, else if for additional checks, and else for the default case. The conditional (ternary) operator (condition ? valueIfTrue : valueIfFalse) is a compact one-line if-else. In C++, a condition is a bool, but numbers and pointers are also accepted: 0 counts as false and any non-zero value counts as true.",
   "keyPoints": [
    "if evaluates a condition that converts to bool (0 is false, non-zero is true)",
    "Only ONE branch of if/else if/else executes",
    "Order matters — the first true branch wins",
    "The ternary operator is great for simple assignments",
    "Be careful: = assigns a value while == compares, and writing if (x = 5) is a common bug"
   ],
   "codeExamples": [
    {
     "title": "Grading system",
     "code": "#include <iostream>\n#include <string>\n\nint main() {\n    int score = 85;\n    std::string grade;\n\n    if (score >= 90) {\n        grade = \"A\";\n    } else if (score >= 80) {\n        grade = \"B\";\n    } else if (score >= 70) {\n        grade = \"C\";\n    } else {\n        grade = \"F\";\n    }\n    std::cout << \"Grade: \" << grade << std::endl;\n    return 0;\n}",
     "output": "Grade: B"
    },
    {
     "title": "Ternary operator",
     "code": "#include <iostream>\n#include <string>\n\nint main() {\n    int age = 20;\n    std::string status = (age >= 18) ? \"Adult\" : \"Minor\";\n    std::cout << status << std::endl;\n\n    int a = 5, b = 3;\n    int maxValue = (a > b) ? a : b;\n    std::cout << \"Max: \" << maxValue << std::endl;\n    return 0;\n}",
     "output": "Adult\nMax: 5"
    }
   ],
   "quiz": [
    {
     "question": "Given int x = 10; What does this print?\nif (x > 5) std::cout << \"A\";\nelse if (x > 8) std::cout << \"B\";",
     "options": [
      "A",
      "B",
      "AB",
      "Nothing"
     ],
     "correctIndex": 0,
     "explanation": "x > 5 is true first, so \"A\" prints. The else if never runs when a previous branch matched."
    },
    {
     "question": "What value does y get? int y = (7 % 2 == 0) ? 100 : 200;",
     "options": [
      "100",
      "200",
      "7",
      "0"
     ],
     "correctIndex": 1,
     "explanation": "7 % 2 = 1, which is not equal to 0. So the condition is false, and the ternary picks 200."
    },
    {
     "question": "Which statement is TRUE about if-else in C++?",
     "options": [
      "All branches always execute",
      "Only one branch executes",
      "else is required",
      "if can only check numbers"
     ],
     "correctIndex": 1,
     "explanation": "Only the first matching branch runs. else is optional. if can check any condition that converts to bool, such as comparisons, bool variables, or numbers."
    }
   ]
  },
  "c": {
   "title": "Conditional Statements",
   "subtitle": "Make decisions in your code",
   "concept": "if, else if, else, and the ternary operator",
   "explanation": "Conditional statements let your C program take different paths based on conditions. Use if to check a condition, else if for additional checks, and else for the default case. In C, a condition is any scalar expression: 0 means false and any non-zero value means true. Comparison operators like >= give 1 (true) or 0 (false). The ternary operator (condition ? valueIfTrue : valueIfFalse) is a compact one-line if-else. Kapil's tip: be careful to use == for comparing and not = (which assigns)!",
   "keyPoints": [
    "if evaluates an expression: 0 is false, any non-zero value is true",
    "Only ONE branch of if/else if/else executes",
    "Order matters — the first true branch wins",
    "Use == to compare; a single = assigns a value and is a common bug",
    "Ternary is great for simple assignments"
   ],
   "codeExamples": [
    {
     "title": "Grading system",
     "code": "#include <stdio.h>\n\nint main(void) {\n    int score = 85;\n    char grade;\n\n    if (score >= 90) {\n        grade = 'A';\n    } else if (score >= 80) {\n        grade = 'B';\n    } else if (score >= 70) {\n        grade = 'C';\n    } else {\n        grade = 'F';\n    }\n    printf(\"Grade: %c\\n\", grade);\n    return 0;\n}",
     "output": "Grade: B"
    },
    {
     "title": "Ternary operator",
     "code": "#include <stdio.h>\n\nint main(void) {\n    int age = 20;\n    const char *status = (age >= 18) ? \"Adult\" : \"Minor\";\n    printf(\"%s\\n\", status);\n\n    int a = 5, b = 3;\n    int max = (a > b) ? a : b;\n    printf(\"Max: %d\\n\", max);\n    return 0;\n}",
     "output": "Adult\nMax: 5"
    }
   ],
   "quiz": [
    {
     "question": "Given int x = 10; What does this print?\nif (x > 5) printf(\"A\");\nelse if (x > 8) printf(\"B\");",
     "options": [
      "A",
      "B",
      "AB",
      "Nothing"
     ],
     "correctIndex": 0,
     "explanation": "x > 5 is true first, so \"A\" prints. The else if never runs when a previous branch matched."
    },
    {
     "question": "What value does y get? int y = (7 % 2 == 0) ? 100 : 200;",
     "options": [
      "100",
      "200",
      "7",
      "0"
     ],
     "correctIndex": 1,
     "explanation": "7 % 2 is 1, which is not equal to 0. So the condition is false (0), and the ternary gives 200."
    },
    {
     "question": "Which statement is TRUE about if-else in C?",
     "options": [
      "All branches always execute",
      "Only one branch executes",
      "else is required",
      "if can only check comparisons like x > 5"
     ],
     "correctIndex": 1,
     "explanation": "Only the first matching branch runs. else is optional. In C, if can test any scalar expression: non-zero is true, 0 is false."
    }
   ]
  },
  "python": {
   "title": "Conditional Statements",
   "subtitle": "Make decisions in your code",
   "concept": "if, elif, else, and the conditional expression (ternary)",
   "explanation": "Conditional statements let your program take different paths based on conditions. Use if to check a condition, elif (short for 'else if') for additional checks, and else for the default case. Python uses a colon and indentation instead of curly braces to mark each block. Python's ternary operator (value_if_true if condition else value_if_false) is a compact one-line if-else. As Kapil would say: indentation is not just style in Python, it is the syntax!",
   "keyPoints": [
    "if evaluates a condition; any value can be tested, and it is treated as True or False",
    "Only ONE branch of if/elif/else executes",
    "Order matters — the first true branch wins",
    "Blocks are defined by a colon and consistent indentation, not braces",
    "The ternary form 'a if condition else b' is great for simple assignments"
   ],
   "codeExamples": [
    {
     "title": "Grading system",
     "code": "score = 85\n\nif score >= 90:\n    grade = \"A\"\nelif score >= 80:\n    grade = \"B\"\nelif score >= 70:\n    grade = \"C\"\nelse:\n    grade = \"F\"\nprint(\"Grade: \" + grade)",
     "output": "Grade: B"
    },
    {
     "title": "Ternary operator",
     "code": "age = 20\nstatus = \"Adult\" if age >= 18 else \"Minor\"\nprint(status)\n\na, b = 5, 3\nmax_value = a if a > b else b\nprint(\"Max:\", max_value)",
     "output": "Adult\nMax: 5"
    }
   ],
   "quiz": [
    {
     "question": "Given x = 10, what does this print?\nif x > 5:\n    print(\"A\")\nelif x > 8:\n    print(\"B\")",
     "options": [
      "A",
      "B",
      "A B",
      "Nothing"
     ],
     "correctIndex": 0,
     "explanation": "x > 5 is true first, so \"A\" prints. The elif never runs when a previous branch matched."
    },
    {
     "question": "What is the value of y?\ny = 100 if 7 % 2 == 0 else 200",
     "options": [
      "100",
      "200",
      "7",
      "0"
     ],
     "correctIndex": 1,
     "explanation": "7 % 2 is 1, which is not equal to 0. So the condition is False and the value after else, 200, is used."
    },
    {
     "question": "Which statement is TRUE about if/elif/else in Python?",
     "options": [
      "All branches always execute",
      "Only one branch executes",
      "else is required",
      "if can only check numbers"
     ],
     "correctIndex": 1,
     "explanation": "Only the first matching branch runs. else is optional, and if can test any expression, not just numbers."
    }
   ]
  }
 },
 "operators": {
  "python": {
   "title": "Operators & Expressions",
   "subtitle": "Do math and comparisons in Python",
   "concept": "Arithmetic, comparison, and logical operators",
   "explanation": "Operators let you manipulate values. Arithmetic operators (+, -, *, /, //, %, **) perform math. Comparison operators (==, !=, <, >, <=, >=) return boolean results (True or False). Logical operators (and, or, not) combine booleans. The modulo (%) operator gives the remainder, which is very useful in DSA.",
   "keyPoints": [
    "/ always returns a float in Python 3 (e.g., 7 / 2 = 3.5), while // is floor division (e.g., 7 // 2 = 3)",
    "% (modulo) gives the remainder (e.g., 7 % 2 = 1)",
    "== compares values (works for strings too); use 'is' only to check identity, such as 'x is None'",
    "and / or short-circuit for efficiency, and Python lets you chain comparisons like 13 <= age <= 19"
   ],
   "codeExamples": [
    {
     "title": "Arithmetic and modulo",
     "code": "a = 17\nb = 5\nprint(a + b)   # 22\nprint(a - b)   # 12\nprint(a * b)   # 85\nprint(a // b)  # 3 (floor division)\nprint(a % b)   # 2 (remainder)",
     "output": "22\n12\n85\n3\n2"
    },
    {
     "title": "Comparison and logic",
     "code": "age = 20\ncan_vote = age >= 18               # True\nis_teen = 13 <= age <= 19          # False\ninvalid = age < 0 or age > 150     # False\nprint(\"Can vote:\", can_vote)",
     "output": "Can vote: True"
    }
   ],
   "quiz": [
    {
     "question": "What is the value of 15 % 4?",
     "options": [
      "3",
      "3.75",
      "4",
      "11"
     ],
     "correctIndex": 0,
     "explanation": "15 % 4 gives the remainder when 15 is divided by 4. 15 = 4 × 3 + 3, so the remainder is 3."
    },
    {
     "question": "What does 10 // 3 return in Python?",
     "options": [
      "3.33",
      "3",
      "4",
      "Error"
     ],
     "correctIndex": 1,
     "explanation": "The // operator is floor division, so it drops the fractional part. 10 / 3 is 3.33..., but 10 // 3 gives 3."
    },
    {
     "question": "What is the result of: True and (False or True)?",
     "options": [
      "True",
      "False",
      "Error",
      "None"
     ],
     "correctIndex": 0,
     "explanation": "(False or True) is True. Then True and True is True. Parentheses are evaluated first, then and is applied."
    }
   ]
  },
  "c": {
   "title": "Operators & Expressions",
   "subtitle": "Do math and comparisons in C",
   "concept": "Arithmetic, comparison, and logical operators",
   "explanation": "Operators let you manipulate values. Arithmetic operators (+, -, *, /, %) perform math. Comparison operators (==, !=, <, >, <=, >=) produce an int result: 1 for true and 0 for false. Logical operators (&&, ||, !) combine conditions and also give 1 or 0. In C, any non-zero value counts as true and 0 counts as false. The modulo (%) operator gives the remainder, which is very useful in DSA. Kapil often uses it to check even/odd numbers and wrap around array indexes.",
   "keyPoints": [
    "/ is integer division when both operands are int (e.g., 7/2 = 3)",
    "% (modulo) gives the remainder (e.g., 7 % 2 = 1) and works only with integer types",
    "Comparisons and logical operators give int 1 (true) or 0 (false); with <stdbool.h> you can store them in a bool",
    "== on strings (char *) compares addresses, not text; use strcmp() from <string.h> to compare string contents",
    "&& (AND) and || (OR) short-circuit: the right side is skipped if the left side already decides the result"
   ],
   "codeExamples": [
    {
     "title": "Arithmetic and modulo",
     "code": "#include <stdio.h>\n\nint main(void) {\n    int a = 17;\n    int b = 5;\n    printf(\"%d\\n\", a + b);   // 22\n    printf(\"%d\\n\", a - b);   // 12\n    printf(\"%d\\n\", a * b);   // 85\n    printf(\"%d\\n\", a / b);   // 3 (integer division)\n    printf(\"%d\\n\", a % b);   // 2 (remainder)\n    return 0;\n}",
     "output": "22\n12\n85\n3\n2"
    },
    {
     "title": "Comparison and logic",
     "code": "#include <stdio.h>\n#include <stdbool.h>\n\nint main(void) {\n    int age = 20;\n    bool canVote = age >= 18;                 // true\n    bool isTeen = age >= 13 && age <= 19;     // false\n    bool invalid = age < 0 || age > 150;      // false\n    printf(\"Can vote: %d\\n\", canVote);\n    printf(\"Teen: %d, Invalid: %d\\n\", isTeen, invalid);\n    return 0;\n}",
     "output": "Can vote: 1\nTeen: 0, Invalid: 0"
    }
   ],
   "quiz": [
    {
     "question": "What is the value of 15 % 4 in C?",
     "options": [
      "3",
      "3.75",
      "4",
      "11"
     ],
     "correctIndex": 0,
     "explanation": "15 % 4 gives the remainder when 15 is divided by 4. 15 = 4 × 3 + 3, so the remainder is 3."
    },
    {
     "question": "What does 10 / 3 give in C when both are int?",
     "options": [
      "3.33",
      "3",
      "4",
      "Compile error"
     ],
     "correctIndex": 1,
     "explanation": "Integer division discards the fractional part. 10 / 3 is 3.33 mathematically, but C gives 3."
    },
    {
     "question": "What is the value of the expression: 1 && (0 || 1)?",
     "options": [
      "1",
      "0",
      "Compile error",
      "NULL"
     ],
     "correctIndex": 0,
     "explanation": "(0 || 1) is 1 because one side is true. Then 1 && 1 is 1. Parentheses are evaluated first, then && is applied."
    }
   ]
  },
  "cpp": {
   "title": "Operators & Expressions",
   "subtitle": "Do math and comparisons in C++",
   "concept": "Arithmetic, comparison, and logical operators",
   "explanation": "Operators let you manipulate values. Arithmetic operators (+, -, *, /, %) perform math. Comparison operators (==, !=, <, >, <=, >=) return bool results (true or false). Logical operators (&&, ||, !) combine bools. The modulo (%) operator gives the remainder, which is very useful in DSA. Kapil often reminds learners that mastering these small building blocks makes bigger problems much easier.",
   "keyPoints": [
    "/ is integer division when both operands are int (e.g., 7 / 2 = 3); use a double operand like 7 / 2.0 to get 3.5",
    "% (modulo) gives the remainder (e.g., 7 % 2 = 1) and works only with integer types",
    "== compares values for fundamental types and for std::string too, because std::string overloads ==; don't compare C-style char* strings with == (it compares addresses)",
    "&& (AND) and || (OR) short-circuit: the right side is skipped if the left side already decides the result"
   ],
   "codeExamples": [
    {
     "title": "Arithmetic and modulo",
     "code": "#include <iostream>\n\nint main() {\n    int a = 17;\n    int b = 5;\n    std::cout << a + b << \"\\n\";   // 22\n    std::cout << a - b << \"\\n\";   // 12\n    std::cout << a * b << \"\\n\";   // 85\n    std::cout << a / b << \"\\n\";   // 3 (integer division)\n    std::cout << a % b << \"\\n\";   // 2 (remainder)\n    return 0;\n}",
     "output": "22\n12\n85\n3\n2"
    },
    {
     "title": "Comparison and logic",
     "code": "#include <iostream>\n\nint main() {\n    int age = 20;\n    bool canVote = age >= 18;                 // true\n    bool isTeen = age >= 13 && age <= 19;     // false\n    bool invalid = age < 0 || age > 150;      // false\n    std::cout << std::boolalpha;              // print true/false instead of 1/0\n    std::cout << \"Can vote: \" << canVote << \"\\n\";\n    return 0;\n}",
     "output": "Can vote: true"
    }
   ],
   "quiz": [
    {
     "question": "What is the value of 15 % 4?",
     "options": [
      "3",
      "3.75",
      "4",
      "11"
     ],
     "correctIndex": 0,
     "explanation": "15 % 4 gives the remainder when 15 is divided by 4. 15 = 4 × 3 + 3, so the remainder is 3."
    },
    {
     "question": "What does 10 / 3 return in C++ when both are int?",
     "options": [
      "3.33",
      "3",
      "4",
      "Compile error"
     ],
     "correctIndex": 1,
     "explanation": "Integer division discards the fractional part. 10 / 3 is 3.33 mathematically, but C++ gives 3 for two ints."
    },
    {
     "question": "What is the result of: true && (false || true)?",
     "options": [
      "true",
      "false",
      "Compile error",
      "null"
     ],
     "correctIndex": 0,
     "explanation": "(false || true) is true. Then true && true is true. Parentheses are evaluated first, then && is applied."
    }
   ]
  }
 }
};
